/**
 * Copyright 2022 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const ROUTES = {
  index: "/",
};
